import { render, staticRenderFns } from "./RelatedResource.vue?vue&type=template&id=3cba8106"
import script from "./RelatedResource.vue?vue&type=script&lang=js"
export * from "./RelatedResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports